import React, { useEffect, useMemo, useState } from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { Formik, useFormikContext } from 'formik';
import * as yup from 'yup';
import ArrowLeft from 'assets/icons/ic-arrow-left.svg';
import './Assessment.scss';
import { Tab, Tabs } from 'react-bootstrap';
import { TabContent } from 'components/common/TabContent';
import { getAssessment, postAssessment } from 'store/assessmentSingle/actions';
import { useDispatch, useSelector } from 'react-redux';
import { IAppState } from 'store';
import { IAssessmentSingleState } from 'store/assessmentSingle/types';
import { configureValidation, DISABLED_ASSESSMENT_STATUS_FLAG } from './config';
import TableLoader from 'components/TableLoader';
import { CompleteAssessment } from 'components/CompleteAssessment';
import { SaveAssessmentModal } from '../../components/SaveAssessmentModal';
import { ROUTES } from '../../config/routes';
import { getApiAssessment } from '../../store/assessment/actions';
import { useTranslation } from 'react-i18next';
import { translateText } from 'utils/helpers/useTranslation';
import { CONDITIONS } from 'utils/helpers/enum';
import { checkAllConditionsFollow } from 'utils/helpers/useCondition';
import DownloadReportButton from 'components/DownloadReportButton';
import SavePopup from 'components/SavePopup';
import { formDataToPost } from 'utils/helpers/form.data.to.post';

interface IInitialValues {
  [key: string]: string | object;
}

interface IValidationScheme {
  [key: string]: any;
}
interface IProps {
  setDoctId?: React.Dispatch<React.SetStateAction<any>>;
}
const Assessment = () => {
  const { uid } = useParams<{ uid: string }>();
  const dispatch = useDispatch();
  const history = useHistory();
  const [changedFieldsId, setChangedFieldsId] = useState([]);
  const [currentTab, setCurrentTab] = useState();
  const [currentId, setCurrentId] = useState();

  const [formikVal, setFormikVal] = useState();
  const [newDataToPost, setNewDataToPost] = useState([]);
  const [shouldAvtoSave, setShouldAvtoSave] = useState(false);
  const [userHandleSaveData, setUserHandleSaveData] = useState(false);

  const [exitModalOpen, setExitModalOpen] = useState(false);
  const [isHaveErrors, SetIsHaveErrors] = useState(false);
  const { t } = useTranslation();

  const [currentAssesmentID, setCurrentAssesmentID] = useState(0);
  const [saveBeforeExitPopupOpen, setSaveBeforeExitPopupOpen] = useState(false);


  const { data, isLoading, error } = useSelector<
    IAppState,
    IAssessmentSingleState
  >(state => state.singleAssessment);
  const originalData = useSelector((state: IAppState) => state.singleAssessment.originalData);
  const [newData, setNewData] = useState(data);

  const [key, setKey] = useState('');
  const [packageKey, setPackageKey] = useState('');

  useEffect(() => {
    if (data.length > 1) {
      const firstVisibleTab = data?.find(
        el => el.Template.TemplatePageType !== 0,
      );
      setCurrentAssesmentID(data[0]?.ID)
      if (!packageKey) {
        setPackageKey(firstVisibleTab?.Template.Name);
      }
    } else {
      const firstVisibleTab = data?.[0]?.Pages.find(
        el => el.Template.TemplatePageType !== 0,
      );
      setCurrentAssesmentID(data[0]?.ID)
      if (key === '' || !key) {
        setKey(firstVisibleTab?.Template.Name);
      }
    }
  }, [data]);

  useEffect(() => {
    setKey(undefined);
  }, [packageKey]);

  const [initialValues, validSchema] = useMemo(() => {
    const initial: IInitialValues = {};
    const validation: IValidationScheme = {};
    data.forEach(ass => {
      ass?.Pages.forEach(page => {
        page.Fields.forEach(field => {
          if (field.Template.FieldType.Name === 'Grid') {
            const arrayOfFields = [];
            field.GridChildren.forEach(fieldArray => {
              const fieldsObject = {};
              fieldArray.forEach(f => {
                fieldsObject[f.Template.Name] = f.Value;
              });
              arrayOfFields.push(fieldsObject);
            });
            initial[field.Guid] = arrayOfFields;
          } else {
            initial[field.Guid] = field.Value || '';
          }
        });
      });
    });
    return [initial, validation];
  }, [data]);

  useEffect(() => {
    if (uid) {
      dispatch(getAssessment(uid));
    }
  }, [dispatch, uid]);

  useEffect(() => {
    setNewData(data);
  }, [dispatch, data, key]);

  useEffect(() => {}, [newData, data]);

  const onGoBack = (isFormTouched: any) => {
    if (data?.[0]?.StatusFlag === 2 || data?.[0]?.StatusFlag === 5) {
      history.goBack();
      return null;
    }
    if (!!Object.keys(isFormTouched).length) {
      setExitModalOpen(true);
    } else {
      history.goBack();
    }
  };

  const onModalAgree = async () => {
    await dispatch(getApiAssessment());
    setExitModalOpen(false);
    history.goBack();
  };

  const onModalCancel = () => {
    setExitModalOpen(false);
  };

  const haveErrorsHandler = () => {
    SetIsHaveErrors(true);
  };

  console.log(error);

  const saveFieldsData = (pData, values, changedFieldsId) => {
    console.log('saveFieldsData called with:', { pData, values, changedFieldsId });
    const dataToPost = [];

    // Helper function to check if a field has actually changed
    const hasFieldChanged = (field, originalField) => {
      if (!originalField) return true; // New field
      
      if (field.Template.FieldType.Name === 'Grid') {
        // For grid fields, compare GridChildren values
        if (!originalField.GridChildren || field.GridChildren.length !== originalField.GridChildren.length) {
          return true;
        }
        
        for (let i = 0; i < field.GridChildren.length; i++) {
          const currentRow = field.GridChildren[i];
          const originalRow = originalField.GridChildren[i];
          
          if (!originalRow || currentRow.length !== originalRow.length) {
            return true;
          }
          
          for (let j = 0; j < currentRow.length; j++) {
            const currentField = currentRow[j];
            const originalFieldChild = originalRow[j];
            
            if (!originalFieldChild || currentField.Value !== originalFieldChild.Value) {
              return true;
            }
          }
        }
        return false;
      } else {
        // For non-grid fields, compare values
        const currentValue = values[field.Guid];
        const originalValue = originalField.Value;
        return currentValue !== originalValue;
      }
    };

    const processGridField = f => {
      // Find original grid field by Template ID across all pages
      let originalGridField = null;
      if (originalData && originalData[0] && originalData[0].Pages) {
        originalData[0].Pages.forEach(originalPage => {
          if (originalPage.Fields) {
            const foundField = originalPage.Fields.find(originalField => 
              originalField.Template.ID === f.Template.ID
            );
            if (foundField) {
              originalGridField = foundField;
            }
          }
        });
      }
      
      // Preserve existing IDs and generate new ones only for new fields
      f.GridChildren = f.GridChildren.map((row, rowIndex) => 
        row.map((field, fieldIndex) => {
          if (field.ID && typeof field.ID === 'number' && field.ID > 0) {
            return { ...field };
          }
          
          const originalFieldsMap = new Map();
          if (originalGridField?.GridChildren) {
            originalGridField.GridChildren.forEach((origRow, origRowIndex) => {
              origRow.forEach(origField => {
                const key = `${origField.Template.ID}_${origField.GridRow}`;
                originalFieldsMap.set(key, origField);
              });
            });
          }
          
          const key = `${field.Template.ID}_${field.GridRow}`;
          const originalField = originalFieldsMap.get(key);
          
          if (originalField && originalField.ID) {
            console.log(`Found original field for key ${key}: ID=${originalField.ID}, GridRow=${originalField.GridRow}`);
            return { ...field, ID: originalField.ID };
          }
          
          // If not found by position, try to find by Template ID only (for new rows)
          const foundByTemplate = originalGridField?.GridChildren?.flat()?.find(origField => 
            origField.Template.ID === field.Template.ID
          );
          
          if (foundByTemplate && foundByTemplate.ID) {
            console.log(`Found field by template ID: ID=${foundByTemplate.ID}`);
            return { ...field, ID: foundByTemplate.ID };
          }
          
          const newId = Date.now() + Math.random();
          console.log(`Generated new ID: ${newId} for field at row ${rowIndex}`);
          return { ...field, ID: newId };
        })
      );
      f.GridChildren.forEach(fieldsArray => {
        if (fieldsArray && Array.isArray(fieldsArray)) {
          fieldsArray.forEach(field => {
            if (field && field.GridRow < f.GridChildren.length) {
              field.Value = (values[f.Guid] &&
                values[f.Guid][field.GridRow] &&
                values[f.Guid][field.GridRow][field.Template?.Name]) as
                | string
                | null;
            }
          });
        }
      });

      if (changedFieldsId && Array.isArray(changedFieldsId) && changedFieldsId.includes(f.Guid)) {
        // Check if the field has actually changed
        const originalField = originalData?.[0]?.Pages?.find(page => 
          page.Fields?.some(field => field.Template.ID === f.Template.ID)
        )?.Fields?.find(field => field.Template.ID === f.Template.ID);
        
        if (hasFieldChanged(f, originalField)) {
          
          if (originalData && originalData[0] && originalData[0].Pages) {
            originalData[0].Pages.forEach(originalPage => {
              if (originalPage.Fields) {
                const foundField = originalPage.Fields.find(originalField => 
                  originalField.Template.ID === f.Template.ID
                );
              }
            });
          }
        
        // Create payload that matches the expected API format
        const cleanField = {
          ID: f.ID,
          Guid: f.Guid,
          GridRow: f.GridRow,
          GridColumn: f.GridColumn,
          Value: f.Value,
          Template: {
            ID: f.Template.ID,
            Name: f.Template.Name,
            DisplayName: f.Template.DisplayName,
            Required: f.Template.Required,
            Order: f.Template.Order,
            HelpText: f.Template.HelpText,
            GridChild: f.Template.GridChild,
            FieldAlias: f.Template.FieldAlias,
            FieldType_ID: f.Template.FieldType_ID,
            FieldType: {
              ID: f.Template.FieldType.ID,
              Name: f.Template.FieldType.Name,
              Discriminator: f.Template.FieldType.Discriminator
            },
            Parameters_ID: f.Template.Parameters_ID,
            Parameters: f.Template.Parameters || {
              ID: f.Template.Parameters_ID,
              Expression: null,
              ValuesListID: 0,
              MultiLine: false,
              Discriminator: null,
              MeasureDetail_ID: 0,
              ShowRowsAsColumns: false,
              FieldTemplateToMirror_ID: 0
            },
            Validator_ID: f.Template.Validator_ID,
            Validator: f.Template.Validator || {
              ID: f.Template.Validator_ID,
              MinimumDate: null,
              MaximumDate: null,
              MinRows: 0,
              MaxRows: 0,
              AllRowsVisible: false,
              Minimum: 0,
              Maximum: 0,
              IntegerOnly: false,
              MinimumLength: 0,
              MaximumLength: 0,
              Discriminator: null
            },
            OriginalSize: f.Template.OriginalSize,
            OriginalWidth: f.Template.OriginalWidth,
            OriginalHeight: f.Template.OriginalHeight,
            MaintainAspectRatio: f.Template.MaintainAspectRatio,
            InitiallyVisibleOnLoad: f.Template.InitiallyVisibleOnLoad,
            VisibleExternally: f.Template.VisibleExternally,
            Archived: f.Template.Archived,
            ImageOnly: f.Template.ImageOnly,
            HasImage: f.Template.HasImage,
            BackgroundColour: f.Template.BackgroundColour
          },
          GridChildren: f.Template.FieldType.Name === 'Grid' ? 
            f.GridChildren.map(row => 
              row.map(field => ({
                ID: field.ID,
                Guid: field.Guid,
                GridRow: field.GridRow,
                GridColumn: field.GridColumn,
                Value: field.Value,
                Template: {
                  ID: field.Template.ID,
                  Name: field.Template.Name,
                  DisplayName: field.Template.DisplayName,
                  Required: field.Template.Required,
                  Order: field.Template.Order,
                  HelpText: field.Template.HelpText,
                  GridChild: field.Template.GridChild,
                  FieldAlias: field.Template.FieldAlias,
                  FieldType_ID: field.Template.FieldType_ID,
                  FieldType: {
                    ID: field.Template.FieldType.ID,
                    Name: field.Template.FieldType.Name,
                    Discriminator: field.Template.FieldType.Discriminator
                  },
                  Parameters_ID: field.Template.Parameters_ID,
                  Parameters: field.Template.Parameters || {
                    ID: field.Template.Parameters_ID,
                    Expression: null,
                    ValuesListID: 0,
                    MultiLine: false,
                    Discriminator: null,
                    MeasureDetail_ID: 0,
                    ShowRowsAsColumns: false,
                    FieldTemplateToMirror_ID: 0
                  },
                  Validator_ID: field.Template.Validator_ID,
                  Validator: field.Template.Validator || {
                    ID: field.Template.Validator_ID,
                    MinimumDate: null,
                    MaximumDate: null,
                    MinRows: 0,
                    MaxRows: 0,
                    AllRowsVisible: false,
                    Minimum: 0,
                    Maximum: 0,
                    IntegerOnly: false,
                    MinimumLength: 0,
                    MaximumLength: 0,
                    Discriminator: null
                  },
                  OriginalSize: field.Template.OriginalSize,
                  OriginalWidth: field.Template.OriginalWidth,
                  OriginalHeight: field.Template.OriginalHeight,
                  MaintainAspectRatio: field.Template.MaintainAspectRatio,
                  InitiallyVisibleOnLoad: field.Template.InitiallyVisibleOnLoad,
                  VisibleExternally: field.Template.VisibleExternally,
                  Archived: field.Template.Archived,
                  ImageOnly: field.Template.ImageOnly,
                  HasImage: field.Template.HasImage
                },
                GridChildren: field.GridChildren || [],
                Invalid: field.Invalid
              }))
            ) : [],
          Invalid: f.Invalid,
          FieldTemplate_ID: f.Template.ID,
          CollectionID: 0,
          HasImageData: f.Template.HasImage || false
        };
        
        dataToPost.push(cleanField);
        setNewDataToPost([...dataToPost]);
        }
      }
    };

    const processField = f => {
      if (f.Template.FieldType?.Name === 'Grid') {
        processGridField(f);
      } else {
        if (changedFieldsId && Array.isArray(changedFieldsId) && changedFieldsId.includes(f.Guid)) {
          // Check if the field has actually changed
          const originalField = originalData?.[0]?.Pages?.find(page => 
            page.Fields?.some(field => field.Template.ID === f.Template.ID)
          )?.Fields?.find(field => field.Template.ID === f.Template.ID);
          
          if (hasFieldChanged(f, originalField)) {
          
          // Create payload that matches the expected API format for non-grid fields
          const cleanField = {
            ID: f.ID,
            Guid: f.Guid,
            GridRow: f.GridRow,
            GridColumn: f.GridColumn,
            Value: values[f.Guid] as string,
            Template: {
              ID: f.Template.ID,
              Name: f.Template.Name,
              DisplayName: f.Template.DisplayName,
              Required: f.Template.Required,
              Order: f.Template.Order,
              HelpText: f.Template.HelpText,
              GridChild: f.Template.GridChild,
              FieldAlias: f.Template.FieldAlias,
              FieldType_ID: f.Template.FieldType_ID,
              FieldType: {
                ID: f.Template.FieldType.ID,
                Name: f.Template.FieldType.Name,
                Discriminator: f.Template.FieldType.Discriminator
              },
              Parameters_ID: f.Template.Parameters_ID,
              Parameters: f.Template.Parameters || {
                ID: f.Template.Parameters_ID,
                Expression: null,
                ValuesListID: 0,
                MultiLine: false,
                Discriminator: null,
                MeasureDetail_ID: 0,
                ShowRowsAsColumns: false,
                FieldTemplateToMirror_ID: 0
              },
              Validator_ID: f.Template.Validator_ID,
              Validator: f.Template.Validator || {
                ID: f.Template.Validator_ID,
                MinimumDate: null,
                MaximumDate: null,
                MinRows: 0,
                MaxRows: 0,
                AllRowsVisible: false,
                Minimum: 0,
                Maximum: 0,
                IntegerOnly: false,
                MinimumLength: 0,
                MaximumLength: 0,
                Discriminator: null
              },
              OriginalSize: f.Template.OriginalSize,
              OriginalWidth: f.Template.OriginalWidth,
              OriginalHeight: f.Template.OriginalHeight,
              MaintainAspectRatio: f.Template.MaintainAspectRatio,
              InitiallyVisibleOnLoad: f.Template.InitiallyVisibleOnLoad,
              VisibleExternally: f.Template.VisibleExternally,
              Archived: f.Template.Archived,
              ImageOnly: f.Template.ImageOnly,
              HasImage: f.Template.HasImage,
              BackgroundColour: f.Template.BackgroundColour
            },
            GridChildren: [],
            Invalid: f.Invalid,
            FieldTemplate_ID: f.Template.ID,
            CollectionID: 0,
            HasImageData: f.Template.HasImage || false
          };
          
          dataToPost.push(cleanField);
          setNewDataToPost([...dataToPost]);
          } else {
            console.log('Non-grid field has not actually changed, skipping:', f.Guid);
          }
        }
      }
    };

    console.log('Processing data:', data);
    if (data.length > 0) {
      data.forEach(pData => {
        pData?.Pages.forEach(p => {
          p.Fields.forEach(processField);
        });
      });
    } else {
      pData?.forEach(p => p?.Fields.forEach(processField));
    }
  };

  useEffect(() => {
    if (changedFieldsId.length > 0)
      saveFieldsData(currentTab, formikVal, changedFieldsId);
  }, [changedFieldsId, formikVal]);

  useEffect(() => {
    let intervalId;
    
    intervalId = setInterval(() => {
      if (changedFieldsId.length > 0) {
        setShouldAvtoSave(true);
      }
    }, 60000);
    
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [changedFieldsId]);
  
  
  const postAndGetAss = async () => {
    console.log('AUTOSAVE STARTED');
    // const dataToPost = formDataToPost(newData, originalData, changedFieldsId, values)
    await dispatch(postAssessment(newDataToPost, true));
    setChangedFieldsId([]);
    setNewDataToPost([]);
    setShouldAvtoSave(false);
    console.log('AUTOSAVE COMPLITED');

    // dispatch(getAssessment(currentId));
  };
  useEffect(() => {
    if (shouldAvtoSave && changedFieldsId.length > 0) {
      postAndGetAss();
    }
  }, [shouldAvtoSave]);

  useEffect(() => {
    const form = document.getElementById('main-form123');
    form?.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
      }
    });
    if (changedFieldsId.length === 0) {
      setShouldAvtoSave(false);
    }
  }, [changedFieldsId, shouldAvtoSave]);

  const validateForm = (values: any) => {
    const errors: any = {};
    
    const currentDataWithValues = data.map(ass => ({
      ...ass,
      Pages: ass.Pages.map(page => ({
        ...page,
        Fields: page.Fields.map(field => ({
          ...field,
          Value: values[field.Guid] || field.Value
        }))
      }))
    }));
    
    data.forEach(ass => {
      ass?.Pages.forEach(page => {
        page.Fields.forEach(field => {
          const visible = field.Template.InitiallyVisibleOnLoad;
          const noDisplayConditions =
            !field.Template.DisplayConditions ||
            field.Template.DisplayConditions.length === 0;
          const conditionToShow =
            visible ||
            (!visible && noDisplayConditions) ||
            (!visible &&
              !noDisplayConditions &&
              checkAllConditionsFollow(field, currentDataWithValues));
          
          if (conditionToShow) {
            if (field.Template.FieldType?.Name === 'Grid') {
              const gridData = values[field.Guid];
              if (gridData && Array.isArray(gridData)) {
                gridData.forEach((row, rowIndex) => {
                  if (row && typeof row === 'object') {
                    Object.keys(row).forEach(fieldName => {
                      const gridField = field.GridChildren.flat().find(f => f.Template.Name === fieldName);
                      if (gridField && gridField.Template.Required) {
                        const fieldValue = row[fieldName];
                        if (!fieldValue || fieldValue === '') {
                          errors[`${field.Guid}.${rowIndex}.${fieldName}`] = 'This field is required';
                        }
                      }
                    });
                  }
                });
              }
            } else {
              const fieldValue = values[field.Guid];
              const validator = field.Template.Validator;
              
              if (field.Template.Required) {
                if (!fieldValue || fieldValue === '') {
                  errors[field.Guid] = 'This field is required';
                }
              }
              
              if (fieldValue && fieldValue !== '' && validator) {
                const discriminator = validator.Discriminator;
                
                switch (discriminator) {
                  case 'NumericValidator':
                    const numValue = parseFloat(fieldValue);
                    if (isNaN(numValue)) {
                      errors[field.Guid] = 'Must be a valid number';
                    } else {
                      if (validator.Minimum !== undefined && numValue < validator.Minimum) {
                        errors[field.Guid] = `Minimum value is ${validator.Minimum}`;
                      }
                      if (validator.Maximum !== undefined && numValue > validator.Maximum) {
                        errors[field.Guid] = `Maximum value is ${validator.Maximum}`;
                      }
                      if (validator.IntegerOnly && !Number.isInteger(numValue)) {
                        errors[field.Guid] = 'Must be a whole number';
                      }
                    }
                    break;
                    
                  case 'TextValidator':
                    if (validator.MinimumLength !== undefined && fieldValue.length < validator.MinimumLength) {
                      errors[field.Guid] = `Minimum length is ${validator.MinimumLength} characters`;
                    }
                    if (validator.MaximumLength !== undefined && fieldValue.length > validator.MaximumLength) {
                      errors[field.Guid] = `Maximum length is ${validator.MaximumLength} characters`;
                    }
                    break;
                    
                  case 'DateTimeValidator':
                    const dateValue = new Date(fieldValue);
                    if (isNaN(dateValue.getTime())) {
                      errors[field.Guid] = 'Must be a valid date';
                    } else {
                      if (validator.MinimumDate && dateValue < new Date(validator.MinimumDate)) {
                        errors[field.Guid] = `Date must be after ${validator.MinimumDate}`;
                      }
                      if (validator.MaximumDate && dateValue > new Date(validator.MaximumDate)) {
                        errors[field.Guid] = `Date must be before ${validator.MaximumDate}`;
                      }
                    }
                    break;
                    
                  case 'MultiSelectionFieldValidator':
                    if (Array.isArray(fieldValue)) {
                      if (validator.MinRows !== undefined && fieldValue.length < validator.MinRows) {
                        errors[field.Guid] = `Minimum ${validator.MinRows} selections required`;
                      }
                      if (validator.MaxRows !== undefined && fieldValue.length > validator.MaxRows) {
                        errors[field.Guid] = `Maximum ${validator.MaxRows} selections allowed`;
                      }
                    }
                    break;
                }
              }
            }
          }
        });
      });
    });
    
    return errors;
  };

  return (
    <>
      <div className="page-content">
        <div
          className={
            isHaveErrors
              ? 'container-custom container assessment-container invalid'
              : 'container-custom container assessment-container'
          }
        >
          <div className="row">
            <div className="col-12">
              {isLoading ? (
                <TableLoader />
              ) : error ? (
                <p>sorry we have some troubles, reload the page please</p>
              ) : (
                <>
                  <div className="assessment-header">
                    <h2
                      className="assessment-name"
                      onClick={() => {
                        setUserHandleSaveData(true);
                        setShouldAvtoSave(false);
                        setSaveBeforeExitPopupOpen(true);
                      }}
                    >
                      <button className="assessment-back">
                        <img src={ArrowLeft} alt="arrow image" />
                      </button>

                      {data.length > 0 && data[0].Template.Name}
                    </h2>
                    <div className="assessment-buttons">
                      {/* <CompleteAssessment
                              assessmentsId={data?.map(ass => ass.ID)}
                              isHaveErrors={haveErrorsHandler}
                            /> */}
                    </div>
                  </div>
                  <Formik
                    initialValues={initialValues}
                    validate={validateForm}
                    // validateOnChange={false}
                    // validateOnBlur={false}
                    onSubmit={() => console.log('')}
                  >
                    {formik => (
                      <form
                        id="main-form123"
                        onSubmit={e => {
                          e.preventDefault();
                          formik.handleSubmit(e);
                        }}
                      >
                        <div className="tabs-wrapper">
                          {data?.length > 1 ? (
                            <Tabs
                              onSelect={k => setPackageKey(k)}
                              activeKey={packageKey}
                              className="nav nav-tabs primary-tabs package-sticky-header-assesments"
                            >
                              {data?.map(
                                (ass, assesmentIndex) => {
                                  
                                  return (
                                    // ass.Template.TemplatePageType == 0 && (
                                    <Tab
                                      onEnter={() => {
                                        setCurrentAssesmentID(ass.ID);
                                        return null;
                                      }}
                                      className="nav-item nav-link"
                                      title={translateText(
                                        ass.Template.Name,
                                        data,
                                      )}
                                      eventKey={ass.Template.Name}
                                      key={ass.ID}
                                    >
                                      <div className="inner-tabs-wrapper">
                                        <Tabs
                                          className="nav nav-tabs package-sticky-tabs"
                                          activeKey={key}
                                          onSelect={k => setKey(k)}
                                        >
                                          {ass?.Pages.map((p, i) => {
                                            const noDisplayConditions =
                                              !p.Template.DisplayConditions ||
                                              p.Template.DisplayConditions.length < 1;
                                            const conditionToShow =
                                              noDisplayConditions ||
                                              (!noDisplayConditions &&
                                                checkAllConditionsFollow(
                                                  p,
                                                  newData &&
                                                    newData[assesmentIndex],
                                                ));

                                            return (
                                              p.Template.TemplatePageType !==
                                                0 &&
                                              conditionToShow && (
                                                <Tab
                                                  className="nav-item nav-link"
                                                  title={p.Template.Name}
                                                  eventKey={p.Template.Name}
                                                  key={p.ID}
                                                >
                                                  <TabContent
                                                    newDataToPost={
                                                      newDataToPost
                                                    }
                                                    setUserHandleSaveData={
                                                      setUserHandleSaveData
                                                    }
                                                    newData={
                                                      newData &&
                                                      newData[assesmentIndex]
                                                    }
                                                    setFormikVal={setFormikVal}
                                                    setCurrentTab={
                                                      setCurrentTab
                                                    }
                                                    setCurrentId={setCurrentId}
                                                    changedFieldsId={
                                                      changedFieldsId
                                                    }
                                                    setChangedFieldsId={
                                                      setChangedFieldsId
                                                    }
                                                    translations={
                                                      data?.[0]?.Template
                                                        .Translations
                                                    }
                                                    data={p}
                                                    fieldsDisabled={
                                                      ass.StatusFlag ===
                                                      DISABLED_ASSESSMENT_STATUS_FLAG
                                                    }
                                                    pageNum={i}
                                                    assId={ass.ID}
                                                  >
                                                    <CompleteAssessment
                                                      userHandleSaveData={
                                                        userHandleSaveData
                                                      }
                                                      setUserHandleSaveData={
                                                        setUserHandleSaveData
                                                      }
                                                      changedFieldsId={
                                                        changedFieldsId
                                                      }
                                                      setChangedFieldsId={
                                                        setChangedFieldsId
                                                      }
                                                      assessmentsId={
                                                        data?.[0].ID
                                                      }
                                                      isHaveErrors={
                                                        haveErrorsHandler
                                                      }
                                                      dataP={p}
                                                    />
                                                  </TabContent>
                                                </Tab>
                                              )
                                            );
                                          })}
                                        </Tabs>
                                        <DownloadReportButton
                                          assesmentID={ass.ID}
                                        />
                                      </div>
                                    </Tab>
                                  );
                                },
                                // ),
                              )}
                            </Tabs>
                          ) : (
                            <Tabs
                              className="nav nav-tabs single-sticky-tabs"
                              activeKey={key}
                              onSelect={k => setKey(k)}
                            >
                              {data?.[0]?.Pages.map((p, i) => {
                                const noDisplayConditions =
                                  p.Template.DisplayConditions.length < 1 ||
                                  p.Template.DisplayConditions === undefined ||
                                  p.Template.DisplayConditions === null;
                                const conditionToShow =
                                  noDisplayConditions ||
                                  (!noDisplayConditions &&
                                    checkAllConditionsFollow(p, newData));

                                if (p.Template.TemplatePageType !== 0) {
                                  if (conditionToShow) {
                                    return (
                                      <Tab
                                      onEnter={() => {
                                        setCurrentAssesmentID(data?.[0]?.ID);
                                        return null;
                                      }}
                                        className="nav-item nav-link"
                                        title={translateText(
                                          p.Template.Name,
                                          data,
                                        )}
                                        eventKey={p.Template.Name}
                                        key={p.ID}
                                      >
                                        {/* <SavePopup 
                                                   data={newData && newData[0]}
                                                    isOpen={saveBeforeExitPopupOpen} 
                                                    setIsOpen={setSaveBeforeExitPopupOpen} 
                                                    changedFieldsId={changedFieldsId} 
                                                    setChangedFieldsId={setChangedFieldsId} 
                                                    setUserHandleSaveData={setUserHandleSaveData} 
                                                  />  */}
                                        <TabContent
                                          setCurrentId={setCurrentId}
                                          setUserHandleSaveData={
                                            setUserHandleSaveData
                                          }
                                          setFormikVal={setFormikVal}
                                          setCurrentTab={setCurrentTab}
                                          changedFieldsId={changedFieldsId}
                                          setChangedFieldsId={
                                            setChangedFieldsId
                                          }
                                          initialValues={initialValues}
                                          translations={
                                            data?.[0]?.Template.Translations
                                          }
                                          data={p}
                                          newData={newData && newData[0]}
                                          setNewData={setNewData}
                                          fieldsDisabled={
                                            data?.[0].StatusFlag ===
                                            DISABLED_ASSESSMENT_STATUS_FLAG
                                          }
                                          pageNum={i}
                                          assId={data?.[0].ID}
                                        >
                                          <CompleteAssessment
                                            userHandleSaveData={
                                              userHandleSaveData
                                            }
                                            setUserHandleSaveData={
                                              setUserHandleSaveData
                                            }
                                            changedFieldsId={changedFieldsId}
                                            setChangedFieldsId={
                                              setChangedFieldsId
                                            }
                                            assessmentsId={data?.[0].ID}
                                            isHaveErrors={haveErrorsHandler}
                                            dataP={p}
                                          />
                                        </TabContent>
                                        <DownloadReportButton
                                          assesmentID={data?.[0]?.ID}
                                        />
                                      </Tab>
                                    );
                                  }
                                }
                              })}
                            </Tabs>
                          )}
                        </div>
                        <SavePopup
                          data={newData.find(
                            assesment => assesment.ID === currentAssesmentID,
                          )}
                          isOpen={saveBeforeExitPopupOpen}
                          setIsOpen={setSaveBeforeExitPopupOpen}
                          changedFieldsId={changedFieldsId}
                          setChangedFieldsId={setChangedFieldsId}
                          setUserHandleSaveData={setUserHandleSaveData}
                        />
                      </form>
                    )}
                  </Formik>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* <SaveAssessmentModal
        onSave={onModalAgree}
        onExit={onModalCancel}
        isOpen={exitModalOpen}
        text={t('AP_sav?')}
        primaryButtonText={t('AP_agree')}
        cancelButtonText={t('AP_cancel')}
      /> */}
    </>
  );
};

export { Assessment };
